export default (mode = 'business') => ({
  mode,
  init() {
    // find out if we are in the map form or the list form
    let $searchForm = this.$el.querySelector(this.mode === 'event' ? '#views-exposed-form-search-event-search-page' : '#views-exposed-form-business-search-list');
    if (!$searchForm) {
      $searchForm = this.$el.querySelector(this.mode === 'event' ? '#views-exposed-form-search-event-search-map' : '#views-exposed-form-business-search-map');
    }
    if (!$searchForm) {
      console.warn('search form not found in business search, aborting businessFormHelper');
      return;
    }

    const $switchButton = $searchForm.querySelector('#edit-submit-switch');
    if (!$switchButton) {
      console.warn('switch button not found in business search form, aborting businessFormHelper');
      return;
    }

    // Attach different action to form to allow for switch between map and list form
    $switchButton.addEventListener('click', (e) => {
      const submitUrl = e.target.getAttribute('data-submit-url');
      if (submitUrl && submitUrl.length > 0) {
        $searchForm.action = submitUrl;
      } else {
        console.warn('data-submit-url not found in business search form switch button');
      }
    });
  },
});
